import React, { Component } from "react";
import { batch, connect } from "react-redux";
import PropTypes from "prop-types";
import { StyledTextEditorToolbarFormatGroup } from "../../../styled/details/stylesDetails";
import { TldrAction } from "../../../common/statelessView";
import {
  analyticsTrackEvent,
  checkCeleryTaskStatus,
  onSetAsBackgroundRenderArtboard,
} from "../../../../_utils/common";
import {
  setActiveLayer,
  setCrop,
} from "../../../../_actions/textToolbarActions";
import Axios from "axios";
import { REMOVE_IMAGE_BACKGROUND } from "../../../../_actions/endpoints";
import { openAdvancedSettings } from "../../../../_actions/sidebarSliderActions";
import { wsSetAsBackground } from "../../../../_actions/webSocketAction";
import {
  ADVANCED_EDITOR_PANEL,
  ADVANCED_EDITOR_CLIP,
  FeatureCodes,
} from "../../constants";
import { handleHTTPError } from "../../../../_actions/errorHandlerActions";
import connectedFeatureAvailabilityWrapper from "../../../common/withFeatureAvailability";
import { FaCropAlt, FaEraser, FaExpandArrowsAlt } from "react-icons/fa";
import { showToast } from "../../../../_utils/showToast";
import { withTranslation } from "react-i18next";
import { includedFeatures } from "apps/simplified-web/src/_utils/constants";

import TldrUpgradeSubscriptionModal from "../../../common/modals/TldrUpgradeSubscriptionModal";

class ImageEditorToolbar extends Component {
  signalToken = Axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      bgRemoverLoading: false,
      isFeatureLockModalOpen: false,
    };
  }

  onClickSetAsBackground = async () => {
    const {
      canvasRef,
      layerstore: { layers },
      editor: {
        activeElement: { id: activeElementId } = {},
        activePage: { id: activePageId } = {},
      },
      wsSetAsBackground,
    } = this.props;

    if (!layers) return;
    const activeLayerData = layers[activeElementId];
    if (!activeLayerData) return;
    await onSetAsBackgroundRenderArtboard(canvasRef);
    wsSetAsBackground(activePageId, activeElementId);
  };

  render() {
    const { bgRemoverLoading, isFeatureLockModalOpen } = this.state;
    const { editor, location, t } = this.props;
    const { activeElement } = editor;
    return (
      <>
        {!this.props.isMobileView && <div className="tldr-vl" />}
        <StyledTextEditorToolbarFormatGroup>
          <TldrAction
            action={activeElement.mime}
            icon={<FaExpandArrowsAlt />}
            title={t("context_menu.set_as_bg")}
            callback={this.onClickSetAsBackground}
            disabled={activeElement.mime !== "image"}
          />

          <TldrAction
            action={activeElement.mime}
            icon={<FaEraser />}
            title={t("context_menu.remove_bg")}
            callback={() => {
              this.props.checkFeatureAvailability(
                FeatureCodes.BACKGROUND_REMOVER,
                () => this.removeBackground()
              );
            }}
            inProgress={bgRemoverLoading}
            disabled={activeElement.mime !== "image" || bgRemoverLoading}
          />
          {location !== "sidebar" && (
            <TldrAction
              action={activeElement.mime}
              icon={<FaCropAlt />}
              title={t("context_menu.crop_clip")}
              callback={this.showFiltersPanel}
              disabled={activeElement.cropEnable}
            />
          )}
        </StyledTextEditorToolbarFormatGroup>

        {isFeatureLockModalOpen ? (
          <TldrUpgradeSubscriptionModal
            show={isFeatureLockModalOpen}
            featureList={includedFeatures}
            image="https://assets.simplified.co/images/bg-feature-lock.jpg"
            title={t("upgrade_modal.title", { ns: "accounts" })}
            onHide={() => this.setState({ isFeatureLockModalOpen: false })}
          />
        ) : null}
      </>
    );
  }

  showFiltersPanel = (action) => {
    this.props.openAdvancedSettings(
      ADVANCED_EDITOR_PANEL,
      ADVANCED_EDITOR_CLIP
    );
  };

  crop = (action) => {
    const { canvasRef } = this.props;
    canvasRef.handler.cropHandler.start();

    let cropObject = canvasRef.handler.cropHandler.cropObject;
    batch(() => {
      this.props.setActiveLayer(
        cropObject.id,
        cropObject.type,
        cropObject,
        null,
        ADVANCED_EDITOR_CLIP
      );
      this.props.setCrop(true);
    });
  };

  showError = () => {
    const { t } = this.props;
    showToast({
      description: t("editor.remove_bg_error_msg", {
        ns: "workspace",
      }),
      title: t("editor.remove_bg_error_title", { ns: "workspace" }),
      status: "error",
    });
  };

  removeBackground = () => {
    const {
      editor: { activeElement: { id: layerId = null } = null } = null,
      t,
    } = this.props;

    this.setState({ bgRemoverLoading: true });

    Axios.post(
      REMOVE_IMAGE_BACKGROUND,
      {
        layer: layerId,
      },
      { cancelToken: this.signalToken.token }
    )
      .then((res) => {
        showToast({
          description: t("context_menu.please_Wait", { ns: "studio" }),
          title: t("removing_bg", { ns: "studio" }),
          status: "info",
        });
        checkCeleryTaskStatus(res.data.task_id, () => {})
          .then((result) => {
            this.setState({ bgRemoverLoading: false });
            batch(() => {
              if (result?.response?.info?.status_code === 401) {
                this.showError();
              } else {
                showToast({
                  description: t("editor.remove_bg_success", {
                    ns: "workspace",
                  }),
                  title: t("success", { ns: "common" }),
                  status: "success",
                });

                analyticsTrackEvent("removedBackground");
              }
            });
          })
          .catch((error) => {
            this.setState({ bgRemoverLoading: false });
            this.showError();
          });
      })
      .catch((error) => {
        this.setState({ bgRemoverLoading: false });
        batch(() => {
          if (error.response.status === 429) {
            this.setState({ isFeatureLockModalOpen: true });
            this.props.handleHTTPError(error, this.props);
          } else {
            this.showError();
          }
        });
      });
  };
}

ImageEditorToolbar.propTypes = {
  editor: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  editor: state.editor,
  auth: state.auth,
  layerstore: state.layerstore,
  subscription: state.subscription,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveLayer: (
    elementId,
    elementType,
    layerId,
    elementParentId,
    selectedTab
  ) =>
    dispatch(
      setActiveLayer(
        elementId,
        elementType,
        layerId,
        elementParentId,
        selectedTab
      )
    ),
  wsSetAsBackground: (pageId, layerId) =>
    dispatch(wsSetAsBackground(pageId, layerId)),
  setCrop: (isEnable) => dispatch(setCrop(isEnable)),
  openAdvancedSettings: (panelName, selectedTab) =>
    dispatch(openAdvancedSettings(panelName, selectedTab)),
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
});

export default withTranslation(["studio", "billing", "accounts"])(
  connectedFeatureAvailabilityWrapper(
    connect(mapStateToProps, mapDispatchToProps)(ImageEditorToolbar)
  )
);
